import createHTMLMediaHook from "./factory/createHTMLMediaHook"

export const useVideo = createHTMLMediaHook<HTMLVideoElement>("video")
